import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  summaryGrid: {
    display: 'flex',
    borderRadius: 10,
    border: `1px solid ${theme.palette.divider}`,
    overflow: 'hidden',
  },
  summaryItem: {
    flex: 1,
    padding: theme.spacing(3),
    backgroundColor:
      theme.palette.type === 'dark'
        ? 'rgba(255, 255, 255, 0.02)'
        : 'rgba(0, 0, 0, 0.02)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRight: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderRight: 'none',
    },
  },
  summaryLabel: {
    display: 'flex',
    flexDirection: 'column',
    gap: 7,
  },
  summaryIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  summaryText: {
    fontSize: 10,
    fontWeight: 400,
    color: theme.palette.text.secondary,
  },
  summaryValue: {
    fontSize: 36,
    fontWeight: 800,
    color: theme.palette.text.primary,
    lineHeight: 1.5,
  },
}));

type CatalogSummaryItemProps = {
  icon: React.ReactNode;
  label: string;
  count: number;
  iconColor?: string;
};

const CatalogSummaryItem = ({
  icon,
  label,
  count,
  iconColor = '#5292F4',
}: CatalogSummaryItemProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.summaryItem}>
      <Box className={classes.summaryLabel}>
        <Box className={classes.summaryIcon} style={{ color: iconColor }}>
          {icon}
        </Box>
        <Typography className={classes.summaryText}>{label}</Typography>
      </Box>
      <Typography className={classes.summaryValue}>{count}</Typography>
    </Box>
  );
};

type CatalogSummaryGridProps = {
  items: {
    icon: React.ReactNode;
    label: string;
    count: number;
    iconColor?: string;
  }[];
};

export const CatalogSummaryGrid = ({ items }: CatalogSummaryGridProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.summaryGrid}>
      {items.map((item, index) => (
        <CatalogSummaryItem key={index} {...item} />
      ))}
    </Box>
  );
};
